// Main

// icons
import '@/icons/svgLoader';

// vendor
import './vendor/vendor';

// components
import '@/components/components';